import { Combobox } from '#/shared/ui/combobox'
import type { ComboboxOption } from '#/shared/ui/combobox'

import { useProvidersList } from '../model/use-providers-list'

interface SourceComboboxProps {
  value: string
  onValueChange: (value: string) => void
  onProviderSelect?: (option: ComboboxOption) => void
  label?: string
  placeholder?: string
  error?: boolean
  className?: string
}

const ALWAYS_PASS_FILTER = () => true

export function SourceCombobox({
  value,
  onValueChange,
  onProviderSelect,
  label,
  placeholder,
  error,
  className,
}: SourceComboboxProps) {
  const list = useProvidersList(value)
  return (
    <Combobox
      label={label}
      placeholder={placeholder}
      options={list.options}
      value={value}
      onValueChange={onValueChange}
      onSelect={onProviderSelect}
      onOpenChange={list.onOpenChange}
      filter={ALWAYS_PASS_FILTER}
      loading={list.isLoading}
      onLoadMore={list.onLoadMore}
      hasMore={list.hasMore}
      isFetchingMore={list.isFetchingMore}
      error={error}
      className={className}
      clearable
    />
  )
}
